import AGREGAR_CATALOGO_CONTRATO_EVENTO from '@/graphql/mutations/administracion/catalogos/contratos.eventos/agregarCatalogoContratoEvento.gql';
import ACTUALIZAR_CATALOGO_CONTRATO_EVENTO from '@/graphql/mutations/administracion/catalogos/contratos.eventos/actualizarCatalogoContratoEvento.gql';
import REMOVER_CATALOGO_CONTRATO_EVENTO from '@/graphql/mutations/administracion/catalogos/contratos.eventos/removerCatalogoContratoEvento.gql';
import OBTENER_CATALOGO_CONTRATO_EVENTO from '@/graphql/querys/administracion/catalogos/coontratos.eventos/catalogoContratosEventos.gql';

export default {
  apollo: {
    catalogoContratosEventos: {
      query: OBTENER_CATALOGO_CONTRATO_EVENTO,
    },
  },
  methods: {
    async mixAgregarCatalogoContratoEvento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_CATALOGO_CONTRATO_EVENTO,
        variables: {
          contratoEvento: this.catalogoContratoEvento,
        },
        update: (store, { data: { agregarCatalogoContratoEvento } }) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_CONTRATO_EVENTO });
          data.catalogoContratosEventos.push(agregarCatalogoContratoEvento);
          store.writeQuery({ query: OBTENER_CATALOGO_CONTRATO_EVENTO, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixActualizarCatalogoContratoEvento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CATALOGO_CONTRATO_EVENTO,
        variables: {
          id: this.catalogoContratoEventoEditar.id,
          contratoEvento: this.catalogoContratoEvento,
        },
        update: (store, { data: { actualizarCatalogoContratoEvento } }) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_CONTRATO_EVENTO });
          const { catalogoContratosEventos } = data;
          const index = catalogoContratosEventos
            .findIndex(
              (catalogoContratoEvento) => catalogoContratoEvento.id
                === actualizarCatalogoContratoEvento.id,
            );
          if (index !== -1) {
            catalogoContratosEventos.splice(index, 1, actualizarCatalogoContratoEvento);
          }
          store.writeQuery({ query: OBTENER_CATALOGO_CONTRATO_EVENTO, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixEliminarCatalogoContratoEvento(id) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_CONTRATO_EVENTO,
        variables: {
          id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBTENER_CATALOGO_CONTRATO_EVENTO });
          data.catalogoContratosEventos = data.catalogoContratosEventos
            .filter((catalogoContratoEvento) => catalogoContratoEvento.id !== id);
          store.writeQuery({ query: OBTENER_CATALOGO_CONTRATO_EVENTO, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
  },
};
